import { render, staticRenderFns } from "./ModalFornecedorIdentificacao.vue?vue&type=template&id=6ceb6a3f&scoped=true&"
import script from "./ModalFornecedorIdentificacao.vue?vue&type=script&lang=js&"
export * from "./ModalFornecedorIdentificacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalFornecedorIdentificacao.vue?vue&type=style&index=0&id=6ceb6a3f&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb6a3f",
  null
  
)

export default component.exports